var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-3 border-2 border-r--2 pos-r active"},[_c('p',{staticClass:"font-inter-bold fs-3"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"font-inter-bold fs-5"},[_vm._v(_vm._s(_vm.amount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }